import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { Children } from "react";
import cn from "clsx";
import { Container, parseClassnames } from "@crehana/ui";
import MainMenuWithContext from "../MainMenu";
import useNewDashboardTranslations from "./hooks/useNewDashboardTranslations";
import useNewDashboardContext from "./context/useNewDashboardContext";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var NewRouteHeader = function NewRouteHeader(_ref) {
  var _mainMenuProps$rightS;
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    title = _ref.title,
    renderRightSide = _ref.renderRightSide,
    mainMenuProps = _ref.mainMenuProps,
    children = _ref.children;
  var _useNewDashboardTrans = useNewDashboardTranslations(),
    countryCode = _useNewDashboardTrans.countryCode;
  var _useNewDashboardConte = useNewDashboardContext(),
    isDark = _useNewDashboardConte.isDark,
    source = _useNewDashboardConte.source,
    sidebarCollapsed = _useNewDashboardConte.sidebarCollapsed,
    toggleDesignMode = _useNewDashboardConte.toggleDesignMode,
    toggleMobileSideBar = _useNewDashboardConte.toggleMobileSideBar;
  var darkMainMenu = isDark ? 'dark' : 'light';
  var defaultMainMenuProps = _objectSpread(_objectSpread({
    amplitudePageName: source,
    countryPrefix: countryCode,
    position: 'relative',
    embeddedIn: 'new-dashboard',
    layoutConfig: _objectSpread(_objectSpread({}, mainMenuProps === null || mainMenuProps === void 0 ? void 0 : mainMenuProps.layoutConfig), {}, {
      disableLogoRedirection: true,
      hideLoginButton: true,
      hideRegisterButton: true,
      hideSavedCoursesLink: true,
      hideNewCourses: true
    }),
    theme: {
      nav: darkMainMenu,
      submenu: darkMainMenu,
      searchDialog: darkMainMenu,
      searchInput: darkMainMenu,
      searchOverlay: darkMainMenu
    },
    rightSectionProps: _objectSpread(_objectSpread({}, mainMenuProps === null || mainMenuProps === void 0 ? void 0 : mainMenuProps.rightSectionProps), {}, {
      searchLayout: _objectSpread(_objectSpread({}, mainMenuProps === null || mainMenuProps === void 0 ? void 0 : (_mainMenuProps$rightS = mainMenuProps.rightSectionProps) === null || _mainMenuProps$rightS === void 0 ? void 0 : _mainMenuProps$rightS.searchLayout), {}, {
        layout: sidebarCollapsed ? 'sidebar-collapsed' : 'sidebar-expanded'
      })
    })
  }, mainMenuProps), {}, {
    userTheme: darkMainMenu,
    onLeftMenuClick: function onLeftMenuClick() {
      toggleMobileSideBar();
    },
    onChangeStateOpenOverlay: function onChangeStateOpenOverlay(type, opened) {
      if (type === 'CoursesExplorer') {
        toggleDesignMode(opened ? 'Overlay' : undefined);
      }
    }
  });
  var hasChildren = Children.count(children) > 0;
  var hasRightSide = !!renderRightSide;
  var hasChildrenOrRightSide = hasChildren || hasRightSide || !!title;
  var renderTitle = function renderTitle() {
    if (title) {
      return typeof title === 'string' ? /*#__PURE__*/_jsx("h1", {
        className: cn('font-h2', isDark && 'text-white'),
        children: title
      }) : title;
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MainMenuWithContext, _objectSpread({}, defaultMainMenuProps)), hasChildrenOrRightSide && /*#__PURE__*/_jsx("div", {
      className: "w-full",
      children: /*#__PURE__*/_jsxs(Container, {
        type: "dashboard",
        className: parseClassnames(className, 'flex items-start justify-between pt-24 pb-24 sm:pt-40 sm:pb-32'),
        children: [renderTitle(), /*#__PURE__*/_jsxs("div", {
          className: "flex items-center flex-shrink-0",
          "data-tour": "dashboard-header-options",
          children: [children, renderRightSide && renderRightSide()]
        })]
      })
    })]
  });
};
export default NewRouteHeader;